export const classNames = function classNames(...args) {
    return args.join(' ');
};
